import React, { Component } from "react";
import { connect } from "react-redux";

import { workingNoteLocation } from "../../_actions";
import L from "leaflet";
import "./index.css";

const defaultCenter = [-37.814, 144.96332];

class DataMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: this.props.location,
      status: this.props.status,
      icon: this.props.icon
    };
  }

  componentDidMount = () => {
    this.initMap();
  };

  componentWillUnmount = () => {
    if (this.state.map !== undefined) {
      this.state.map.remove();
    }
  };

  /* Function to initialise the map and all the other layers */
  initMap = () => {
    const basemap = L.map("datamap", { zoomControl: false }).setView(
      this.state.location.length > 0 ? [this.state.location[1], this.state.location[0]] : defaultCenter,
      13
    );

    //Setting the base layer for the map
    L.tileLayer("https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png", {
      attribution: `&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>
          &copy; <a href="http://cartodb.com/attributions">CartoDB</a>`,
      subdomains: "abcd"
    }).addTo(basemap);

    const deviceMarkerIcon = this.createDeviceMarkerIcon();
    const noteMarkerIcon = this.createNoteMarkerIcon();

    if (this.state.location.length > 0) {
      L.marker([this.state.location[1], this.state.location[0]], {
        icon: this.props.type === "device" ? deviceMarkerIcon : noteMarkerIcon
      }).addTo(basemap);
    }

    // set the map object
    this.setState(() => {
      return {
        map: basemap
      };
    });
  };

  createDeviceMarkerIcon = () => {
    const tempStatus = this.state.status;
    const tempIcon = this.state.icon;
    const deviceMarkerBackground = this.setMarkerBackgroundBasedOnStatus(tempStatus, "normal");
    const deviceMarkerBackground2x = this.setMarkerBackgroundBasedOnStatus(tempStatus, "retina");
    const deviceMarkerImage = this.setMarkerImageBasedOnType(tempIcon);
    const deviceMarkerImage2x = this.setMarkerImageBasedOnType(tempIcon, "retina");

    return L.icon({
      iconUrl: deviceMarkerImage,
      iconRetinaUrl: deviceMarkerImage2x,
      shadowUrl: deviceMarkerBackground,
      shadowRetinaUrl: deviceMarkerBackground2x,
      iconSize: [24, 30],
      shadowSize: [24, 30],
      // marker point at the bottom center.
      iconAnchor: [12, 29]
    });
  };

  setMarkerBackgroundBasedOnStatus = (status, size) => {
    let devicMarkerBackground = "";
    let devicMarkerBackground2x = "";
    if (status === "online") {
      devicMarkerBackground = require("../../_images/sensor-bg-online-2x.png");
      devicMarkerBackground2x = require("../../_images/sensor-bg-online-2x.png");
    } else if (status === "offline") {
      devicMarkerBackground = require("../../_images/sensor-bg-offline-2x.png");
      devicMarkerBackground2x = require("../../_images/sensor-bg-offline-2x.png");
    } else if (status === "retired") {
      devicMarkerBackground = require("../../_images/sensor-bg-retired-2x.png");
      devicMarkerBackground2x = require("../../_images/sensor-bg-retired-2x.png");
    } else if (status === "unmonitored") {
      devicMarkerBackground = require("../../_images/sensor-bg-unmonitored-2x.png");
      devicMarkerBackground2x = require("../../_images/sensor-bg-unmonitored-2x.png");
    } else {
      devicMarkerBackground = require("../../_images/sensor-bg-unmonitored-2x.png");
      devicMarkerBackground2x = require("../../_images/sensor-bg-unmonitored-2x.png");
    }
    if (size === "retina") {
      return devicMarkerBackground2x;
    } else {
      return devicMarkerBackground;
    }
  };

  setMarkerImageBasedOnType = (type, size) => {
    let devicMarkerImage = "";
    let devicMarkerImage2x = "";

    if (type === "microphone") {
      devicMarkerImage = require("../../_images/sensor-noise-2x.png");
      devicMarkerImage2x = require("../../_images/sensor-noise-2x.png");
    } else if (type === "vibration") {
      devicMarkerImage = require("../../_images/sensor-vibrate-2x.png");
      devicMarkerImage2x = require("../../_images/sensor-vibrate-2x.png");
    } else if (type === "air_quality") {
      devicMarkerImage = require("../../_images/sensor-air-2x.png");
      devicMarkerImage2x = require("../../_images/sensor-air-2x.png");
    } else if (type === "multiple_sensors") {
      devicMarkerImage = require("../../_images/sensor-multiple-2x.png");
      devicMarkerImage2x = require("../../_images/sensor-multiple-2x.png");
    } else {
      devicMarkerImage = require("../../_images/device-sensor-2x.png");
      devicMarkerImage2x = require("../../_images/device-sensor-2x.png");
    }
    if (size === "retina") {
      return devicMarkerImage2x;
    } else {
      return devicMarkerImage;
    }
  };

  createNoteMarkerIcon = () => {
    const noteMarkerBackground = require("../../_images/note-bg.png");
    const noteMarkerBackground2x = require("../../_images/note-bg-2x.png");
    const noteMarkerImage = require("../../_images/note-note.png");
    const noteMarkerImage2x = require("../../_images/note-note-2x.png");

    return L.icon({
      iconUrl: noteMarkerImage,
      iconRetinaUrl: noteMarkerImage2x,
      shadowUrl: noteMarkerBackground,
      shadowRetinaUrl: noteMarkerBackground2x,
      iconSize: [24, 30],
      shadowSize: [24, 30],
      // marker point at the bottom center.
      iconAnchor: [12, 29]
    });
  };

  render = () => {
    const center = this.state.location;
    if (center) {
      return <div id="datamap" />;
    } else {
      return null;
    }
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(mapStateToProps, { workingNoteLocation })(DataMap);



// WEBPACK FOOTER //
// ./src/_components/DataMap/index.js